import smartquotes from 'smartquotes';
import { ready } from './helpers/jQueryReplacements';

ready(() => {
  if (document.querySelectorAll('.pressrelease').length === 0) {
    // replace straight quotes with smart quotes
    smartquotes();
    // account for insertion of native ads
    smartquotes.listen();
  }
});
